export default __webpack_public_path__ + "static/media/21.5129dcce.jpg";